// /** IE9, IE10 and IE11 requires all of the following polyfills. **/
// import "react-app-polyfill/ie11";
// import "react-app-polyfill/stable";
// import "promise-polyfill/src/polyfill";
// import "unfetch/polyfill";
// import "abortcontroller-polyfill";
// /** IE9, IE10 and IE11 requires all of the following polyfills. **/
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
// import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register({ immediate: true });

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
